// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2094":"c80b14de45c01c97","2109":"debd11cd6a847908","3472":"d263e1332dad8ace","8862":"c62ec8db3cdb5da4"}[chunkId] + ".css";
};